import useMediaQuery from '@polestar/component-warehouse-react/hooks/useMediaQuery';
export const useMobileMode = () => {
    const { queryMatches } = useMediaQuery();
    return queryMatches.mobile;
};
export const aimingDelta = (a, b) => {
    return (b.y - a.y) / (b.x - a.x);
};
const traverseGroups = (groups, path) => {
    groups === null || groups === void 0 ? void 0 : groups.map((group, groupIndex) => {
        (group === null || group === void 0 ? void 0 : group.items) &&
            group.items.map((item, index) => {
                // @ts-ignore temporary until typing is fixed
                item.path = `${path}.${groupIndex}.${index}`;
                item.groups && traverseGroups(item.groups, `${path}.${groupIndex}`);
            });
    });
};
export const addKeysToNavigationDrawer = (providedLinks, path = 'nav') => {
    if (providedLinks && providedLinks.length) {
        // @ts-ignore
        return providedLinks.map(({ links, ...props }, linkIndex) => {
            // @ts-ignore
            (props === null || props === void 0 ? void 0 : props.groups) && traverseGroups(props.groups, `${path}.${linkIndex}`);
            return {
                ...props,
                index: linkIndex,
                path: `${path}.${linkIndex}`,
                ...(links
                    ? {
                        links: addKeysToNavigationDrawer(links, `${path}.${linkIndex}`),
                    }
                    : {}),
            };
        });
    }
    return providedLinks;
};
export const focusElementWithIndexResult = (index, refs) => {
    var _a, _b;
    (_b = (_a = refs[index]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
    return index;
};
export const getPreviousFocusPath = (currentFocusPath) => currentFocusPath ? currentFocusPath.split('.').slice(0, -1).join('.') : null;
/**
 * Ensure grouping is supported in flat lists
 *
 * @internal
 */
export const flattenGroupsIntoLinks = (groups) => {
    const list = [];
    groups === null || groups === void 0 ? void 0 : groups.map((group, index) => {
        var _a;
        (_a = group === null || group === void 0 ? void 0 : group.items) === null || _a === void 0 ? void 0 : _a.map((item) => {
            list.push({
                groupType: group.groupType,
                groupIndex: index,
                ...item,
            });
        });
    });
    return list;
};
